import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['height', 'width'];
  
  setHeightAndWidth(event) {
    var value = event.target.options[event.target.options.selectedIndex].value;

    if (value.includes('x')) {
      var size = value.split('x');
      this.widthTarget.value = size[0];
      this.heightTarget.value = size[1];
    } else {
      // Do Nothing
    }
  }
}
